export default "__VITE_ASSET__DY9YoxsE__"